import { Table as AntTable } from "antd";
import { Key, TablePaginationConfig } from "antd/lib/table/interface";

import { pipe } from "fp";

import React, { useState } from "react";

import { useDispatch } from "~/Action";
import * as Data from "~/Data";
import * as Driver from "~/Driver/index";
import * as Messaging from "~/Messaging";

import * as Messenger from "./Messenger";

const useLoading = () =>
  pipe(
    Driver.useStore(),
    Data.Store.when({
      loading: () => true,
      success: () => false,
      error: () => false,
    })
  );

export type TableData = {
  readonly key: string;
  readonly messenger: Messaging.Summary.DriverWithSummaries;
};

export type FilterState = {
  readonly messenger: readonly string[];
};

const useData = (): readonly TableData[] => {
  const search = Messaging.Search.useSearch();
  return pipe(
    Messaging.Summary.useDriversWithMessageSummaries(),
    (driversWithSummaries) =>
      driversWithSummaries.filter((data) =>
        Messaging.Search.matches(
          Driver.Name.toString(data.driver.name) ?? "",
          search
        )
      ),
    (driversWithSummaries) =>
      driversWithSummaries.map((data) => ({
        key: data.driver.id,
        messenger: {
          driver: data.driver,
          summary: data.summary,
        },
      }))
  );
};

export const Component = () => {
  const dispatch = useDispatch();
  const [filterState, setFilterState] = useState<FilterState>({
    messenger: [Messenger.Column.withMessages()],
  });
  const changeHandler = (
    _pagination: TablePaginationConfig,
    filters: Record<string, readonly Key[] | null>
  ) => setFilterState(filters as FilterState);

  return (
    <AntTable
      pagination={false}
      showSorterTooltip={true}
      loading={useLoading()}
      columns={Column.list(filterState) as never}
      dataSource={useData() as never}
      scroll={{ y: "calc(80vh - 50px)" }}
      onChange={changeHandler}
      onRow={(record) => {
        return {
          onClick: () =>
            dispatch(
              Messaging.MessageInteraction.Action.Updated.create(
                record.messenger.driver
              )
            ),
        };
      }}
    />
  );
};

namespace Column {
  export const list = (filterState: FilterState) =>
    [Messenger.Column.column(filterState)] as const;
}
